import React, { Suspense } from 'react';
import CircularProgress from '../../../components_base/CircularProgress';

const CounterpartyEdit = React.lazy(() => import('../components/CounterpartyEdit'));
function CounterpartyEditView(props: any) {
  return (
    <Suspense fallback={<CircularProgress />}>
      <CounterpartyEdit {...props} />
    </Suspense>
  );
}

export default CounterpartyEditView;
